const topics = [
  {
    label: '热播剧场',
    desc: '追踪最新上线的热门电视剧，同步更新不落进度',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20TV%20series%20collage%20with%20dramatic%20lighting%2C%20modern%20entertainment%20aesthetic%2C%20film%20scene%20montage%20with%20soft%20amber%20and%20gold%20highlights%2C%20movie%20theater%20atmosphere%2C%20professional%20cinematography%20style%2C%20no%20visible%20text&width=800&height=450&seq=index-topic-01&orientation=landscape',
    count: '2,560部',
  },
  {
    label: '电影大片',
    desc: '国内外院线大片一网打尽，高清画质畅享观影',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20movie%20poster%20collection%20with%20dramatic%20contrast%20lighting%2C%20cinematic%20feel%2C%20warm%20golden%20and%20deep%20shadow%20tones%2C%20blockbuster%20film%20aesthetic%2C%20professional%20movie%20art%2C%20dark%20background%20with%20warm%20accents%2C%20no%20text&width=800&height=450&seq=index-topic-02&orientation=landscape',
    count: '3,820部',
  },
  {
    label: '综艺娱乐',
    desc: '热门综艺全集收录，搞笑、竞技、真人秀全都有',
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20with%20colorful%20lighting%20and%20warm%20atmosphere%2C%20entertainment%20studio%20set%20design%2C%20energetic%20mood%2C%20golden%20and%20amber%20stage%20lights%2C%20professional%20broadcast%20aesthetic%2C%20no%20people%20visible&width=800&height=450&seq=index-topic-03&orientation=landscape',
    count: '1,450部',
  },
  {
    label: '动漫专区',
    desc: '日漫国漫精品合集，ACG爱好者的一站式追番平台',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20collection%20with%20warm%20lighting%20and%20vibrant%20colors%2C%20Japanese%20animation%20aesthetic%2C%20manga%20inspired%20art%2C%20soft%20golden%20highlights%2C%20cinematic%20composition%2C%20professional%20digital%20art%2C%20no%20text&width=800&height=450&seq=index-topic-04&orientation=landscape',
    count: '3,100部',
  },
  {
    label: '纪录片库',
    desc: '自然人文历史纪录片大全，开阔视野的最佳选择',
    cover: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20style%20imagery%20with%20warm%20earth%20tones%2C%20mountains%20and%20landscapes%20in%20golden%20light%2C%20cinematic%20documentary%20photography%2C%20professional%20wildlife%20and%20nature%20shots%2C%20rich%20amber%20and%20warm%20colors%2C%20no%20text&width=800&height=450&seq=index-topic-05&orientation=landscape',
    count: '980部',
  },
  {
    label: '短剧频道',
    desc: '热门短剧全集速看，碎片时间也能追完一部好剧',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20vertical%20video%20aesthetic%20with%20warm%20lighting%2C%20short%20drama%20series%20style%2C%20cinematic%20portrait%20mode%20shots%20with%20soft%20amber%20glow%2C%20contemporary%20digital%20entertainment%2C%20clean%20composition%2C%20professional%20filmmaking%20style%2C%20no%20text&width=800&height=450&seq=index-topic-06&orientation=landscape',
    count: '2,230部',
  },
  {
    label: '经典怀旧',
    desc: '重温那些年的经典影视，岁月沉淀的不朽佳作合集',
    cover: 'https://readdy.ai/api/search-image?query=Vintage%20film%20aesthetic%20with%20warm%20sepia%20tones%2C%20classic%20movie%20reels%20and%20old%20cinema%20equipment%2C%20nostalgic%20atmosphere%2C%20golden%20age%20of%20cinema%20style%2C%20soft%20warm%20lighting%2C%20antique%20photography%20feel%2C%20no%20text&width=800&height=450&seq=index-topic-07&orientation=landscape',
    count: '1,680部',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            内容导航
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            热门专题合集
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            向日葵视频为你精心整理七大内容板块，快速找到想看的影视资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {topics.slice(0, 4).map((item, idx) => (
            <a
              key={idx}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.label}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700">
                  {item.count}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-900 font-heading">
                  {item.label}
                </h3>
                <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-5">
          {topics.slice(4).map((item, idx) => (
            <a
              key={idx + 4}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-36 overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.label}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700">
                  {item.count}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-900 font-heading">
                  {item.label}
                </h3>
                <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}